<main class="dashboard-layout">
  <ng-content />
</main>
